/**
 * Fraud check applied to the supplier's bank account on an invoice.
 * Published accounts exist only for CZ/SK suppliers; elsewhere a register mode checks use only.
 */
export const SupplierBankAccountCheck = {
  /** No check. */
  OFF: 'OFF',
  /** The account is on an approved invoice from this supplier, or the supplier published it. */
  USED_OR_PUBLISHED: 'USED_OR_PUBLISHED',
  /** Stricter — the supplier must have published the account. */
  PUBLISHED_ONLY: 'PUBLISHED_ONLY',
  /** The account is on an approved invoice from this supplier. */
  USED_ONLY: 'USED_ONLY',
  /** The account is one of the supplier's accounts verified by two signatures, for any country. */
  VERIFIED_ONLY: 'VERIFIED_ONLY'
} as const;

export type SupplierBankAccountCheck =
  (typeof SupplierBankAccountCheck)[keyof typeof SupplierBankAccountCheck];
